import fetch from 'isomorphic-fetch'
import { getAPIendpointPrefix } from './apiHelper.js'

import {
  LOAD_STUDENT_ROSTER_REQUEST,
  LOAD_STUDENT_ROSTER_SUCCESS,
  LOAD_STUDENT_ROSTER_FAILURE
} from '../actions'

import {
  LCRP_GET_ALL_ACTIVITIES_SUCCESS,
  LCRP_GET_ALL_ACTIVITIES_FAILURE
} from '../../lcrp/actions'

import { getStudentTopicalPerformance } from '../lib/macmillan'

export default ({ assignmentId, courseId }) => {
  return async (dispatch, getState) => {
    dispatch({ type: LOAD_STUDENT_ROSTER_REQUEST })

    const endpoint = getAPIendpointPrefix() + 'api/v1/instructor_roster.php' +
      `?assignmentId=${assignmentId}&courseId=${courseId}`

    let json

    try {
      const response = await fetch(endpoint)
      const contentType = response.headers.get('content-type')

      if (!contentType || !contentType.includes('application/json')) {
        throw response.statusText
      }

      json = await response.json()
      dispatch({ type: LOAD_STUDENT_ROSTER_SUCCESS, payload: json })
    } catch (error) {
      return dispatch({ type: LOAD_STUDENT_ROSTER_FAILURE, payload: error })
    }

    try {
      const { assignmentOverview } = getState().core.courseDashboardData
      const { consul } = getState().core
      const updatedAssignmentOverview = await getStudentTopicalPerformance(
        json.dashboardRoster, assignmentOverview, consul
      )
      return dispatch({ type: LCRP_GET_ALL_ACTIVITIES_SUCCESS, payload: updatedAssignmentOverview })
    } catch (error) {
      return dispatch({ type: LCRP_GET_ALL_ACTIVITIES_FAILURE, payload: error })
    }
  }
}
